import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { set_timeout } from '@/utils/utils_client';
import { useCallback, useRef } from 'react';
import { use_effect } from '../_base/use_effect';

export function use_debounced_function<T extends (...args: any[]) => void>(callback: T, delay_ms: number) {
  /*
   * STATE
   */

  const ref_timeout = useRef(CONSTANTS__client.NUMBER_EMPTY_VALUE);

  const run_callback_after_delay_cached = useCallback(run_callback_after_delay, [callback, delay_ms]);

  /*
   * EFFECTS
   */
  use_effect(() => {
    return () => cancel();
  }, [callback, delay_ms]);

  /*
   * METHODS
   */

  function run_callback_after_delay(...args: Parameters<T>) {
    cancel();

    ref_timeout.current = set_timeout(() => callback(...args), delay_ms);
  }

  function cancel() {
    clearTimeout(ref_timeout.current);

    ref_timeout.current = NaN;
  }

  /*
   * RESULT
   */

  return run_callback_after_delay_cached;
}
